<template>
  <div class="clock-card" :style="myStyle" @click="handlerJumpPage">
    <div class="top" v-if="dataObj.isTop">置顶</div>
    <div class="card-top">
      <div class="user-avatar">
        <img alt="avatar" :src="avatar" v-lazy="avatar" />
      </div>
      <div class="card-top-right">
        <div class="user-name" v-if="dataObj.myData">{{ dataObj.myData.nickname }}</div>
        <div class="group-name" v-if="dataObj.groupName">{{dataObj.groupName}}</div>
      </div>
      <template v-if="dataObj.level">
        <img
          :src="require(`@/assets/clock/grade-s.png`)"
          alt=""
          class="grade"
          v-if="dataObj.level === 1"
        />
        <img
          :src="require(`@/assets/clock/grade-a.png`)"
          alt=""
          class="grade"
          v-if="dataObj.level === 2"
        />
        <img
          :src="require(`@/assets/clock/grade-b.png`)"
          alt=""
          class="grade"
          v-if="dataObj.level === 3"
        />
        <img
          :src="require(`@/assets/clock/grade-c.png`)"
          alt=""
          class="grade"
          v-if="dataObj.level === 4"
        />
      </template>
    </div>
    <div class="content">
      <!-- 文本内容 -->
      <p class="text" v-if="text" v-html="text"></p>
      <!-- 图片内容 -->
      <div class="img-list" :class="{'img-sty': dataObj.img.length > 1}" v-if="dataObj.img.length > 0">
        <lazy-component>
          <ClockInImg
            :url="item"
            :index="index"
            :length="dataObj.img.length"
            :noLongPress="noLongPress"
            :size="size"
            @myClick="prevviewImg"
            v-for="(item, index) in dataObj.img"
            :key="index"
          />

          <div class="img-empty" v-if="dataObj.img.length === 2 || dataObj.img.length === 5"></div>
        </lazy-component>
      </div>
      <!-- 音频内容 -->
      <div class="audio" v-if="dataObj.record.length > 0">
        <ClockInAudio
          v-for="(item, index) in dataObj.record"
          :audioSrc="item"
          :wxRecord="false"
          :key="index + 'record'"
        />
      </div>
      <!-- 视频内容 -->
      <ClockInVideo :url="dataObj.video" v-if="dataObj.video" />
    </div>
    <div class="tool">
      <div class="datetime">{{ dataObj.date }}</div>
      <div class="tool-btn">
        <!-- 编辑按钮 -->
        <div
          class="tool-tabar mar-rig"
          @click.stop="handlerEdit"
          v-if="isEdit"
        >
          <img
            src="@/assets/clock/feed_icon_like_edit.png"
            alt="edit"
            class="tool-icon"
          />
          <div>编辑</div>
        </div>
        <!-- 点赞按钮 -->
        <div class="tool-tabar mar-rig" @click.stop="handlerStar">
          <img src="@/assets/clock/feed_icon_like_orange.png" alt="star" class="tool-icon" v-show="isLike">
          <img src="@/assets/clock/feed_icon_like_gray.png" alt="star" class="tool-icon" v-show="!isLike">
          <div>
            {{ dataObj.star.length ? dataObj.star.length : "赞" }}
          </div>
        </div>
        <div class="tool-tabar mar-rig" @click.stop="handlerDelete" v-if="isAdmin">
          <img
            src="@/assets/clock/clockin_icon_delete.png"
            alt="delete"
            class="tool-icon"
          />
          <div>删除</div>
        </div>
        <!-- 评论按钮 -->
        <div class="tool-tabar" @click.stop="handlerComment">
          <img
            src="@/assets/clock/feed_icon_comment.png"
            alt="comment"
            class="tool-icon"
          />
          <div v-if="!isAdmin">
            {{ dataObj.commentCount? dataObj.commentCount : "评" }}
          </div>
          <div v-else>点评</div>
        </div>
      </div>
    </div>
    <!-- 评论和点赞列表 -->
    <div
      class="card-bottom"
      v-if="dataObj.star.length > 0 || dataObj.commentList.length > 0"
    >
      <div class="divider"></div>
      <!-- 点赞列表 -->
      <div class="star-list" v-if="dataObj.star.length > 0">
        <img
          src="@/assets/clock/feed_icon_like_gray.png"
          alt=""
          class="star-icon"
        />
        <div class="star-user" v-for="(item, index) in dataObj.star" :key="index">
          <img :src="item.portrait" alt="" class="star-avatar" />
          <span>{{ item.nickname }}</span>
          <span v-if="index !== dataObj.star.length - 1">,&nbsp;&nbsp;</span>
        </div>
      </div>
      <!-- 评论列表 -->
      <div class="comment-list" v-if="dataObj.commentList.length > 0">
        <p
          class="user-com-item"
          v-for="(item, index) in dataObj.commentList"
          :key="index"
        >
          <span
            v-if="!item.reply_id"
            :class="item.assistant_reply ? 'user-spe' : 'user-com-name'"
            @click.stop="
              handlerComment({
                replyId: item.id,
                name: item.user_meta.nickname,
              })
            "
          >
            {{ item.user_meta.nickname + "：" }}
          </span>

          <template v-if="item.reply_id">
            <span
              :class="item.reply_is_assistant ? 'user-spe' : 'user-com-name'"
              @click.stop="
                handlerComment({
                  replyId: item.id,
                  name: item.user_meta.nickname,
                })
              "
              >{{ item.user_meta.nickname }}</span
            >
            <span class="reply-text">回复</span>
            <span class="user-com-name">{{
              item.reply_user_meta.nickname + "："
            }}</span>
          </template>

          <span
            @click.stop="
              handlerComment({
                replyId: item.id,
                name: item.user_meta.nickname,
              })
            "
            >{{ item.content }}</span
          >
        </p>
        <div
          class="com-tip-text"
          v-if="dataObj.commentCount - dataObj.commentList.length > 0"
          @click.stop="handlerLoadComment"
        >
          加载更多
          <img
            src="@/assets/clock/icon_dropdown_gray.png"
            alt="down"
            class="down-icon"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ImagePreview, Dialog } from 'vant';
import ClockInAudio from '@/components/clockInAudio/index.vue';
import ClockInImg from '@/components/clockInImg/index.vue';
import ClockInVideo from '@/components/ClockInVideo/index.vue';

import { like, dislike } from '@/api/clockin';
import { resizeAlcdnUrl } from '@/common/js/utils';
import { ref, watch } from '@vue/composition-api';
import Cookies from 'js-cookie';
import router from '@/router';

export default {
  props: {
    myStyle: {
      type: String,
      default: 'background: #fff;',
    },
    dataObj: {
      type: Object,
      default() {
        return {
          // 我的打卡数据
          id: '', // 打卡ID
          level: 0, // 评级，1-s 2-a 3-b 4-c
          myData: '', // 打卡用户自己的头像/用户名等数据
          date: '', // 打卡日期
          isTop: 0, // 是否置顶
          content: '', // 文本内容
          video: '', // 视频链接
          record: [], // 录音数据
          img: [], // 图片数据
          star: [], // 点赞的用户数据
          commentCount: 0, // 评论总数
          commentList: [], // 评论列表
          groupName: ''
        };
      }
    },
    isEdit: {
      // 是否可编辑
      type: Boolean,
      default: false,
    },
    noLongPress: {
      // 是否要禁止图片长按事件
      type: Boolean,
      default: false
    },
    isAdmin: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: '29.03vw'
    }
  },
  components: {
    ClockInAudio,
    ClockInImg,
    ClockInVideo,
  },
  setup(props, { emit }) {
    const userId = +Cookies.get('user_id');
    if (!userId) {
      router.replace({
        path: '/login'
      });
    }

    // 设置用户自己是否赞了该内容
    const isLike = ref(false);
    watch(() => props.dataObj.star, (val) => {
      if (!val || !val.length) {
        isLike.value = false;
        return;
      }

      isLike.value = val.some(item => item.id === userId);
    }, { immediate: true });

    // 设置文本内容
    const text = ref('');
    watch(() => props.dataObj.content, (val) => {
      if (!val) {
        text.value = '';
        return;
      }

      text.value = props.dataObj.content.replace(/\n/g, '<br>');
    }, { immediate: true });

    // 设置用户头像
    const avatar = ref(props.dataObj.myData.portrait);
    if (avatar.value) {
      avatar.value = resizeAlcdnUrl(avatar.value, 40);
    }

    /**
     * @description 点击卡片跳转到打卡详情页
     */
    const handlerJumpPage = () => {
      router.push(`/clock-in-detail/${props.dataObj.id}`);
    };

    /**
     * @description 编辑事件
     */
    const handlerEdit = () => {
      emit('edit');
    };

    /**
     * @description 点赞事件
     */
    const handlerStar = () => {
      if (!isLike.value) {
        // 点赞
        like(props.dataObj.id).then(() => {
          isLike.value = true;

          emit('star', { id: props.dataObj.id, isLike: true });
        });
      } else {
        // 取消点赞
        dislike(props.dataObj.id).then(() => {
          isLike.value = false;

          emit('star', { id: props.dataObj.id, isLike: false });
        });
      }
    };

    /**
     * @description 评论事件
     */
    const handlerComment = (data) => {
      emit('clickComment', {
        user_punch_id: props.dataObj.id,
        reply_id: data ? data.replyId : '',
        name: data ? data.name : '',
      });
    };

    /**
     * @description 预览图片
     */
    const prevviewImg = (index) => {
      ImagePreview(props.dataObj.img, index);
    };

    /**
     * @description 加载评论
     */
    const handlerLoadComment = () => {
      const comments = props.dataObj.commentList.filter(item => item.isLocal !== true);

      emit('loadMoreComment', {
        up_id: props.dataObj.id,
        limit: 20,
        last_id: comments[comments.length - 1].id
      });
    };

    /**
     * @description 删除打卡
     */
    const handlerDelete = () => {
      Dialog.confirm({
        title: '删除打卡',
        message: '删除打卡后不可恢复',
        confirmButtonText: '确认删除',
        confirmButtonColor: '#ff9645',
        cancelButtonColor: '#999999'
      })
        .then(() => {
          emit('my-delete', props.dataObj.id);
        })
        .catch(() => {});
    };

    return {
      text,
      avatar,
      isLike,
      handlerJumpPage,
      handlerEdit,
      handlerStar,
      handlerComment,
      prevviewImg,
      handlerLoadComment,
      handlerDelete
    };
  }
};
</script>

<style lang="stylus" scoped>
.clock-card {
  position: relative;
  overflow: hidden;
  margin: 0 auto;
  margin-bottom: 10px;
  padding: 20px 16px;
  width: 100%;

  .top {
    position: absolute;
    top: 5px;
    left: -15px;
    width: 60px;
    height: 20px;
    background: linear-gradient(180deg, #FCDE70 0%, #FFC44D 100%);
    box-shadow: 0px 1px 3px 0px rgba(236, 172, 44, 0.23);
    font-size: 12px;
    line-height: 20px;
    text-align: center;
    color: #D88C03;
    transform: rotate(-45deg);
  }

  .card-top {
    display: flex;
    align-items: center;
    height: 40px;

    .user-avatar {
      width: 40px;
      height: 40px;
      border-radius: 50%;
      background: #eee;

      img {
        width: 100%;
        height: 100%;
        border-radius: 50%;
      }
    }

    .card-top-right {
      margin-left: 8px;
    }

    .user-name {
      font-size: 14px;
      color: #191919;
    }

    .group-name {
      font-size 12px
      color #999
      transform scale(.9) translateX(-6%)
    }
  }

  .grade {
    position: absolute;
    top: 8px;
    right: 8px;
    width: 68px;
    height: 68px;
  }

  .content {
    padding-top: 18px;
    font-size: 15px;
    line-height: 22px;
    color: #191919;

    .text {
      width 100%
      margin-bottom: 12px;
      word-break: break-all
    }

    .img-list {
      margin-bottom: 4px;
      width: 100%;
    }

    .img-sty>div {
      display: flex;
      flex-wrap: wrap;
      align-content space-between
      justify-content space-between
    }

    .img-empty {
      width: 101px;
      height: 101px;
    }

    .audio {
      margin-bottom: 4px;
      width: 210px;
    }
  }

  .tool {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 12px;
    color: #999;

    .tool-btn {
      display: flex;
      align-items: center;
      justify-content: flex-end;

      .tool-tabar {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 30px;
      }

      .tool-icon {
        display: block;
        margin-right 2px
        width: 18px;
        height: 18px;
        border: none;
      }

      .mar-rig {
        margin-right: 24px;
      }
    }
  }
}

.card-bottom {
  width: 100%;

  .divider {
    margin: 16px 0;
    width: 100%;
    height: 0.5px;
    background: #E7E7E7;
  }

  .star-list {
    display: flex;
    flex-wrap: wrap;
    align-content: center;

    .star-icon {
      margin-right: 4px;
      width: 18px;
      height: 18px;
    }

    .star-avatar {
      margin-right 2px
      width: 14px;
      height: 14px;
      border-radius: 50%;
    }

    .star-user {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 18px;
      font-size: 14px;
      color: #999;
    }
  }

  .comment-list {
    margin-top: 12px;

    .user-com-item {
      margin-bottom: 8px;
      padding: 0;
      font-size: 14px;
      line-height: 22px;
      color: #191919;
    }

    .user-com-name {
      color: #999;
    }

    .user-spe {
      color: #FF9645;
    }

    .reply-text {
      margin: 0 4px;
    }
  }
}

.com-tip-text {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  color: #999;

  .down-icon {
    width: 12px;
    height: 12px;
  }
}
</style>
